import type * as z from 'zod'

type ErrorProps = {
    message?: string
    issues?: z.ZodIssue[]
}

function ErrorPage({ message, issues }: ErrorProps) {
    return (
        <>
            <div>Error: {message}</div>
            {/* Include the issues in a `<script>` tag so it can be parsed by the consumer. */}
            {issues ? (
                <script
                    type="application/json"
                    id="issues"
                    // biome-ignore lint/security/noDangerouslySetInnerHtml: we control the content and it allows escaping `&quote`
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(issues),
                    }}
                />
            ) : null}
        </>
    )
}

export default ErrorPage
